export default __webpack_public_path__ + "static/media/CEDlogo.1899a425.png";